import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import PostBookingInfoGraphic from './PostBookingInfoGraphic';

interface PostBookingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PostBookingModal: React.FC<PostBookingModalProps> = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl w-[95vw] sm:w-full max-h-[90vh] overflow-y-auto p-0">
        <DialogHeader className="sr-only">
          <DialogTitle>Booking Information</DialogTitle>
        </DialogHeader>
        <PostBookingInfoGraphic onClose={onClose} className="p-3 sm:p-6" />
      </DialogContent>
    </Dialog>
  );
};

export default PostBookingModal;